import React, { useState, useEffect } from 'react';
import BsModal from '../Common/BsModal';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxGym from '../../util/remote/ajaxGym';
import { useGym } from '../../DataStore/Gym/GymContext';

const MemberFinder = ({ show, onClose, onProceed, onRegister }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [memberInfo, setMemberInfo] = useState(null);
  const [error, setError] = useState("");
  const [buttonLabel, setButtonLabel] = useState("Find Customer");
  const [buttonIcon, setButtonIcon] = useState("search");
  const { storeCustomerPhoneNumber } = useGym();

  useEffect(() => {
    if (memberInfo) {
      setButtonLabel("Proceed to Payment");
      setButtonIcon("arrow-right");
    } else if (error) {
      setButtonLabel("Register Member");
      setButtonIcon("user-plus");
    } else {
      setButtonLabel("Find Customer");
      setButtonIcon("search");
    }
  }, [memberInfo, error]);

  const handleSearch = async () => {
    setLoading(true);
    setError("");
    setMemberInfo(null);
    storeCustomerPhoneNumber(phoneNumber);

    const server_response = await ajaxGym.fetchPhoneDetails(phoneNumber);
    setLoading(false);

    if (server_response.status === "OK") {
      setMemberInfo(server_response.details);
    } else {
      setError("Member not found. Please register them.");
    }
  };

  const handleContinue = async () => {
    if (!memberInfo && !error) {
      await handleSearch();
      return;
    }

    if (memberInfo) {
      onProceed(memberInfo);
    } else {
      onRegister(phoneNumber);
    }
    onClose();
  };

  const handleChange = (e) => {
    setPhoneNumber(e.target.value);
    setMemberInfo(null);
    setError("");
    setButtonLabel("Find Customer");
    setButtonIcon("search");
  };

  const onCancel = () => {
    setPhoneNumber("");
    setMemberInfo(null);
    setError("");
    setButtonLabel("Find Customer");
    setButtonIcon("search");
    onClose();
  }

  return (
    <BsModal
      show={show}
      onClose={onCancel}
      title="Membership Payment"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button
            type="button"
            className={`btn btn-${memberInfo ? 'success' : error ? 'info' : 'primary'}`}
            onClick={handleContinue}
            disabled={!phoneNumber || loading}
          >
            <i className={`fa fa-${buttonIcon} mr-1`}></i>
            {buttonLabel}
          </button>
        </>
      }
    >
      <form method="post" onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
        <div className="form-group">
          <label htmlFor="phoneNumber" className="font-weight-bold">
            <i className="fa fa-phone mr-2 text-primary"></i> Phone Number:
          </label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id="phoneNumber"
              placeholder="Enter phone number"
              value={phoneNumber}
              onChange={handleChange}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-primary"
                type="submit"
                disabled={!phoneNumber || loading}
              >
                {loading ? <ActivityLoader inline={true} /> : <i className="fa fa-search"></i>}
              </button>
            </div>
          </div>
          <small className="text-muted">Search for the gym member by phone number.</small>
        </div>

        {memberInfo && (
          <div className="alert alert-success">
            <strong>Member Found:</strong> {memberInfo.full_name} ({memberInfo.membership_type?.type_name})
          </div>
        )}

        {error && (
          <div className="alert alert-warning">
            <strong>Notice:</strong> {error}
          </div>
        )}
      </form>
    </BsModal>
  );
};

export default MemberFinder;
